/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Fact_Lot_SizeInputs */

const cs_public_site_fact_lot_size = /** @type {(inputs: Public_Site_Fact_Lot_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plocha pozemku`)
};

const en_public_site_fact_lot_size = /** @type {(inputs: Public_Site_Fact_Lot_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lot size`)
};

/**
* | output |
* | --- |
* | "Lot size" |
*
* @param {Public_Site_Fact_Lot_SizeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_fact_lot_size = /** @type {((inputs?: Public_Site_Fact_Lot_SizeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Fact_Lot_SizeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_fact_lot_size(inputs)
	return cs_public_site_fact_lot_size(inputs)
});